import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createFolder = async (object) => {
  try {
    if (object?.droppable) delete object.droppable;
    return makeGraphQLRequest(
      graphqlOperation(mutations.createFolders, { input: object })
    );
  } catch (error) {
    console.error("Error creating Folder:", error);
    throw error;
  }
};

const updateFolder = async (id, args) => {
  try {
    // First, fetch the current version of the Folder
    const getFolderResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getFolders, { id })
    );
    const currentFolder = getFolderResponse.data.getFolders;

    // Prepare the update input
    const updateInput = { id, _version: currentFolder._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateFolders, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating Folder:", error);
    throw error;
  }
};

const deleteFolder = async (id) => {
  try {
    // First, fetch the current version of the Folder
    const getFolderResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getFolders, { id })
    );
    const currentFolder = getFolderResponse.data.getFolders;

    return makeGraphQLRequest(
      graphqlOperation(mutations.deleteFolders, {
        input: { id, _version: currentFolder._version },
      })
    );
  } catch (error) {
    console.error("Error deleting Folder:", error);
    throw error;
  }
};
const getFoldersByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.foldersByWorkspaceID, { workspaceID: workspaceID })
  );

export default {
  createFolder,
  updateFolder,
  deleteFolder,
  getFoldersByWorkspaceID,
};
